var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_329_402)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6404 12.6596C15.1994 10.1006 15.1994 5.95174 12.6404 3.39279C10.0815 0.833836 5.93258 0.833835 3.37363 3.39279C0.814676 5.95174 0.814676 10.1006 3.37363 12.6596C5.93258 15.2185 10.0815 15.2185 12.6404 12.6596Z",
    fill: "#FE646F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00838 10.0035C7.86296 10.0035 7.73851 9.87941 7.71327 9.70875L6.96944 4.69186C6.87593 4.06004 7.28411 3.48083 7.82278 3.48083H8.19362C8.73229 3.48083 9.14047 4.06004 9.04696 4.69186L8.30313 9.70875C8.27824 9.87941 8.1538 10.0035 8.00838 10.0035Z",
    fill: "#E6E9ED"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.68919 11.8908C8.68919 11.516 8.38341 11.2103 8.00866 11.2103C7.6339 11.2103 7.32812 11.516 7.32812 11.8908C7.32812 12.2656 7.6339 12.5713 8.00866 12.5713C8.38341 12.5713 8.68919 12.2659 8.68919 11.8908Z",
    fill: "#E6E9ED"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_329_402"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError1);
export default __webpack_public_path__ + "static/media/error 1.04b71b420aa35d60300815c65d5c0f5d.svg";
export { ForwardRef as ReactComponent };